import type { FeaturePill } from '@/config/marketing-content/types'
import { cn } from '@/lib/utils'

export function FeaturePillGrid({
  pills,
  className,
}: {
  pills: FeaturePill[]
  className?: string
}) {
  const isDetailed = pills.some((pill) => pill.description)

  return (
    <div
      className={cn(
        'feature-showcase-pill-grid',
        isDetailed && 'feature-showcase-pill-grid--detailed',
        className
      )}
    >
      {pills.map((pill) => (
        <div key={pill.label} className="feature-showcase-pill-grid__item">
          {isDetailed ? (
            <>
              <h3 className="feature-showcase-pill-grid__title">{pill.label}</h3>
              {pill.description ? (
                <p className="feature-showcase-pill-grid__description">{pill.description}</p>
              ) : null}
            </>
          ) : (
            pill.label
          )}
        </div>
      ))}
    </div>
  )
}
